"use client";

import React, { useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GoogleReviews() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  useEffect(() => {
    const scriptId = "elfsight-platform-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://elfsightcdn.com/platform.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);
  const serviceAreas = ["Durham", "Raleigh", "Cary", "Chapel Hill", "Wake Forest", "Hillsborough", "Morrisville"];
  return <section id="googlereviews" ref={sectionRef} className="relative overflow-hidden bg-background py-24 sm:py-32">
      {}
      <div className="pointer-events-none absolute left-8 top-8 hidden font-mono text-xs text-muted-foreground/30 md:block">
        +
      </div>
      <div className="pointer-events-none absolute right-8 top-8 hidden font-mono text-xs text-muted-foreground/30 md:block">
        +
      </div>
      <div className="pointer-events-none absolute bottom-8 left-8 hidden font-mono text-xs text-muted-foreground/30 md:block">
        +
      </div>
      <div className="pointer-events-none absolute bottom-8 right-8 hidden font-mono text-xs text-muted-foreground/30 md:block">
        +
      </div>

      {}
      <div className="pointer-events-none absolute left-4 top-1/2 hidden -translate-y-1/2 -rotate-90 font-mono text-[10px] tracking-[0.2em] text-muted-foreground/40 xl:block">
        [ SEC. 04 / REVIEWS ]
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={contentRef} className={`mx-auto max-w-5xl rounded-lg bg-accent p-4 shadow-xl transition-all duration-1000 ease-out sm:p-8 md:p-12 ${isContentVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          <div className="text-center">
            <Badge variant="outline" className="mb-8 border-primary bg-primary/10 px-4 py-1.5 font-mono text-xs font-bold tracking-[0.15em] text-primary uppercase">
               TRUSTED BY LOCAL HOMEOWNERS
            </Badge>

            <h2 className="font-default mb-6 text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-6xl">
              See Why Families{" "}
              <span className="font-serif italic text-primary">Choose Us</span>
            </h2>

            <p className="mx-auto mb-10 max-w-2xl text-lg leading-relaxed text-muted-foreground sm:text-xl">
              Protecting Homes. Protecting Families.
              <br className="hidden sm:block" />
              {" It's Our Promise."}
            </p>

            <div className="mb-16 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <Button asChild size="lg" className="w-full font-bold tracking-widest uppercase sm:w-auto">
                <Link to="/ContactPage">Get Your Free Quote</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="w-full border-primary font-bold tracking-widest text-primary uppercase hover:bg-primary hover:text-primary-foreground sm:w-auto">
                <Link to="https://g.page/r/CYyQJftL-lKmEBM/review" newTab>
                  Leave A Review
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative z-10 min-h-[250px] w-full sm:min-h-[300px]">
            <div className="elfsight-app-bd14037f-e9d1-480c-a6ff-f65338812bdf" data-elfsight-app-lazy></div>
          </div>

          {}
          <div className="mt-16 border-t border-border/40 pt-8 text-center">
            <p className="mb-3 font-mono text-xs font-semibold tracking-[0.15em] text-muted-foreground uppercase">
              Proudly Serving
            </p>
            <p className="text-sm font-medium text-foreground sm:text-base">
              {serviceAreas.join(" • ")}
            </p>
          </div>
        </div>
      </div>
    </section>;
}